export default __webpack_public_path__ + "static/media/1-4-2.bd14690b.jpg";